import React from 'react'

const DiscoveryContext = React.createContext({})

export default DiscoveryContext
